import { memo, useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import ProductCollectionService from "services/product_collection";
import ProductCollectionImage from "./ProductCollectionImage";
import ProductCollectionCarousel from "./ProductCollectionCarousel";
import ProductCollectionCarouselSmall from "./ProductCollectionCarouselSmall";

const service = new ProductCollectionService();

const ProductCollectionsBlock = ({ data }) => {
  const [collections, setCollections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const ids = data?.setting?.collection_ids || [];
        if (!Array.isArray(ids) || ids.length === 0) {
          setCollections([]);
          return;
        }

        const list = await service.getListCollection(ids);
        setCollections(list);
      } catch (error) {
        console.error(error);
        setCollections([]);
      }
    };

    load();
  }, [data]);

  if (collections.length === 0) {
    return <Text>Chưa có collection</Text>;
  }

  const rawDisplay = data?.setting?.display || "list";
  const display = rawDisplay === "image" ? "list" : rawDisplay;
  const autoplay = data?.setting?.slide_config?.autoplay ?? true;
  const commonConfig = data?.setting?.common_config || data?.setting?.list_config || {};

  const onOpenCollection = (item) => {
    if (item.url_handle) {
      navigate(`/collection/${item.url_handle}`);
      return;
    }
    navigate(`/product-collection/${item.id}`);
  };

  switch (display) {
    case "carousel":
      return (
        <ProductCollectionCarousel
          collections={collections}
          autoplay={autoplay}
          onOpenCollection={onOpenCollection}
          commonConfig={commonConfig}
        />
      );
    case "carousel_small":
      return (
        <ProductCollectionCarouselSmall
          collections={collections}
          autoplay={autoplay}
          onOpenCollection={onOpenCollection}
          commonConfig={commonConfig}
        />
      );
    case "list":
    default:
      return (
        <ProductCollectionImage
          collections={collections}
          onOpenCollection={onOpenCollection}
          commonConfig={commonConfig}
        />
      );
  }
};

export default memo(ProductCollectionsBlock);
